import React from "react";
import "./ConsultationSection.scss";
import agentphoto from "./della.jpeg";

/**
 * ConsultationSection
 * Layout split 2 kolom: kiri copy + CTA WhatsApp, kanan foto agent
 * full-height dengan nama & jobtitle di-overlay di atas foto.
 * Reusable lewat props biar bisa dipakai ulang untuk tiap project.
 *
 * Contoh pemakaian:
 * <ConsultationSection
 *   agentName="Albert"
 *   agentRole="Marketing Agent"
 *   agentPhoto="/assets/agents/albert.jpg"
 *   projectName="ALTEA BLVD"
 *   whatsappNumber="6289510613901"
 * />
 */
const ConsultationSection = ({
  agentName = "Della Natalia",
  agentRole = "Marketing Agent",
  projectName = "Summarecon Bekasi",
  title,
  paragraphs,
  whatsappNumber = "6289510613901",
  whatsappMessage,
  ctaLabel = "Hubungi via WhatsApp",
}) => {
  const resolvedTitle =
    title || `Konsultasikan Hunian ${projectName} Bersama Kami`;

  const resolvedParagraphs = paragraphs || [
    `Lagi cari tahu soal hunian di ${projectName}? ${agentName} bisa bantu jelasin pilihan unit yang paling sesuai, hitungan simulasi cicilan, sampai alur pembeliannya, jadi Anda nggak perlu bingung harus mulai dari mana.`,
    `Tiap orang punya kebutuhan dan budget yang beda-beda, dan ${agentName} akan dengar dulu sebelum kasih rekomendasi. Konsultasinya gratis, tanpa biaya apa pun.`,
  ];

  const resolvedMessage =
    whatsappMessage ||
    `Halo ${agentName}, saya ingin konsultasi seputar properti ${projectName}`;

  const waLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
    resolvedMessage,
  )}`;

  return (
    <section className="consultation-section">
      <div className="consultation-section__container">
        <div className="consultation-section__card">
          <div className="consultation-section__content">
            <h2 className="consultation-section__title">{resolvedTitle}</h2>

            {resolvedParagraphs.map((paragraph, index) => (
              <p className="consultation-section__desc" key={index}>
                {paragraph}
              </p>
            ))}

            <a
              className="consultation-section__cta"
              href={waLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path d="M2 3.5A1.5 1.5 0 013.5 2h1.148a1.5 1.5 0 011.465 1.175l.716 3.223a1.5 1.5 0 01-.826 1.68l-1.293.646a11.05 11.05 0 005.516 5.516l.646-1.293a1.5 1.5 0 011.68-.826l3.223.716A1.5 1.5 0 0118 15.352V16.5a1.5 1.5 0 01-1.5 1.5H15c-1.149 0-2.263-.15-3.326-.43A13.022 13.022 0 012.43 8.326 13.019 13.019 0 012 5V3.5z" />
              </svg>
              {ctaLabel}
            </a>
          </div>

          <div className="consultation-section__photo-panel">
            <img src={agentphoto} alt={agentName} />

            <span className="consultation-section__role-badge">
              {agentRole}
            </span>

            <div className="consultation-section__photo-caption">
              <p className="consultation-section__agent-name">{agentName}</p>
              <p className="consultation-section__agent-sub">
                Mitra Pemasaran {projectName}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConsultationSection;
